import { NavLink } from 'react-router-dom';

const TABS = [
  { to: '/dev-console/providers', label: 'Overview', end: true },
  { to: '/dev-console/providers/spend', label: 'Spend history', end: false },
  { to: '/dev-console/providers/health', label: 'Reliability', end: false },
] as const;

/**
 * Route-backed tab bar for the Providers section. Deliberately routes (not
 * local-state tabs like the analytics dashboard): ops URLs get pasted into
 * incident threads, so each view must be directly addressable.
 */
export function ProvidersNav() {
  return (
    <nav className="flex gap-1 mb-6 border-b border-border overflow-x-auto">
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.end}
          className={({ isActive }) =>
            `px-3 py-2 text-sm -mb-px border-b-2 whitespace-nowrap ${
              isActive
                ? 'border-primary text-foreground font-medium'
                : 'border-transparent text-muted-foreground hover:text-foreground'
            }`
          }
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
